export default __webpack_public_path__ + "static/media/inhalationvideo.f156fabc.svg";